import type { SdkMixin } from '@wix/lean-components-infra';
import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';
import {
  reportError,
  messageTemplates,
  composeSDKFactories,
  changePropsSDKFactory,
  isValidUrl,
  createAccessibilityPropSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import { createLeanComponentSDK } from '@wix/lean-components-infra/runtime/sdk';
import type { CorvidTypes } from '@wix/editor-elements-types/corvid';
import type { IShareButtonsProps } from '../ShareButtons.props';
import { PagesToShare } from '../constants';

const sdkSchema = {
  pageToShare: {
    type: 'string',
  },
};

const validationSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    pageToShare: {
      type: ['string'],
    },
  },
};

const mixins = ['changeable'] as Array<SdkMixin>;

export const leanSdk = createLeanComponentSDK<IShareButtonsProps>({
  sdkSchema,
  validationSchema,
  mixins,
});

const _shareButtonsSDKFactory: CorvidTypes.CorvidSDKFactory<
  IShareButtonsProps,
  any
> = ({ setProps, props }) => {
  const sdkProps = {
    get pageToShare() {
      return props.pageToShare;
    },
    set pageToShare(value) {
      if (
        Object.values(PagesToShare).includes(value as PagesToShare) ||
        isValidUrl(value)
      ) {
        setProps({ pageToShare: value });
      } else {
        reportError(
          messageTemplates.error_type({
            propertyName: 'pageToShare',
            functionName: 'pageToShare',
            value,
            expectedType: `"home", "current" or a valid URL`,
          }),
        );
      }
    },
  };
  return sdkProps;
};

const accessibilityPropsSDKFactory = createAccessibilityPropSDKFactory({
  enableLang: true,
});

export const sdk = composeSDKFactories<IShareButtonsProps, any>([
  leanSdk,
  _shareButtonsSDKFactory,
  changePropsSDKFactory,
  accessibilityPropsSDKFactory,
]);

export default createComponentSDKModel(
  composeSDKFactories([leanSdk, accessibilityPropsSDKFactory]),
);
